export const COURSE_LAYOUT = {
    LAYOUT_NORMAL : "layout_normal",
    LAYOUT_LECTURES_ONLY : "layout_lectures_only"    
}